<template>
  <div>
    <view-table
        ref="viewTable"
        :limits="limits"
        :columns-property="columnsProperty"
        :filter="filter"
        module="basic"
        url="invoiceApplications/selectToDoInvoiceWithPage"
        @reset="resetHandle"
        @delete="deleteHandle"
        @addOrEdit="addEditHandle"
        @select="selectHandle">
      <template slot="adSearch">
        <div class="vm-search">
          <el-form :inline="true" :model="filter" label-width="80px" @keyup.enter.native="loadData(1)">
            <el-form-item label="订单编号">
              <el-input
                  v-model.trim="filter.billNos"
                  type="textarea"
                  autosize
                  placeholder="请输入单据编号"
                  clearable/>
            </el-form-item>
            <el-form-item label="能否开票">
              <el-select v-model="filter.availableInvoice" clearable>
                <el-option label="可开票" value="可开票"/>
                <el-option label="不可开票" value="不可开票"/>
              </el-select>
            </el-form-item>
            <el-form-item label="物料号">
              <el-input v-model.trim="filter.materialNo" placeholder="请输入物料号" clearable/>
            </el-form-item>
            <el-form-item label="发运状态">
              <el-select v-model="filter.completeEndState" clearable placeholder="请选择发运状态">
                <el-option label="全部" value=""/>
                <el-option label="未发运" value="未发运"/>
                <el-option label="已发运" value="已发运"/>
              </el-select>
            </el-form-item>
            <el-form-item label="规格型号">
              <el-input v-model.trim="filter.specification" placeholder="请输入规格型号" clearable/>
            </el-form-item>
            <el-form-item label="物料描述">
              <el-input v-model.trim="filter.materialName" placeholder="请输入物料描述" clearable/>
            </el-form-item>
            <el-form-item label="过账状态">
              <el-select v-model="filter.postingStatus" clearable placeholder="请选择过账状态">
                <el-option label="全部" value=""/>
                <el-option label="未过账" value="未过账"/>
                <el-option label="已过账" value="已过账"/>
              </el-select>
            </el-form-item>
            <el-form-item label="签收状态">
              <el-select v-model="filter.invoiceReceiveDesc" clearable placeholder="请选择签收状态">
                <el-option label="全部" value=""/>
                <el-option label="未签收" value="未签收"/>
                <el-option label="已签收" value="已签收"/>
              </el-select>
            </el-form-item>
            <el-form-item label="客户名称">
              <el-input v-model.trim="filter.customerName" placeholder="请输入客户名称" clearable/>
            </el-form-item>
            <el-form-item label="客户合同号">
              <el-input v-model.trim="filter.customerContractNo" placeholder="请输入客户合同号" clearable/>
            </el-form-item>
            <el-form-item label="创建人">
              <el-input v-model.trim="filter.employeeName" placeholder="请输入创建人" clearable/>
            </el-form-item>
            <el-form-item label="类型">
              <el-select v-model="filter.type" clearable placeholder="请选择类型">
                <el-option label="全部" value=""/>
                <el-option label="发货单" value="发货单"/>
                <el-option label="销售订单" value="销售订单"/>
              </el-select>
            </el-form-item>
            <el-form-item label="发运日期">
              <el-date-picker
                  v-model="deliveryDateRange"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始时间"
                  end-placeholder="结束时间"
                  value-format="yyyy-MM-dd"
                  @change="dateRangeChange('deliveryDateRange', 'deliveryBeginDate', 'deliveryEndDate')"/>
            </el-form-item>
            <el-form-item label="过账时间">
              <el-date-picker
                  v-model="postDateRange"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始时间"
                  end-placeholder="结束时间"
                  value-format="yyyy-MM-dd"
                  @change="dateRangeChange('postDateRange', 'postBeginDate', 'postEndDate')"/>
            </el-form-item>
            <el-form-item label="签收时间">
              <el-date-picker
                  v-model="signDateRange"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始时间"
                  end-placeholder="结束时间"
                  value-format="yyyy-MM-dd"
                  @change="dateRangeChange('signDateRange', 'signBeginDate', 'signEndDate')"/>
            </el-form-item>
          </el-form>
        </div>
      </template>
      <template slot="otherBtn">
        <el-button v-if="limits.invoiceAuth" type="primary" :disabled="!selection.length" @click="handle()">
          开票申请
        </el-button>
      </template>
    </view-table>
  </div>
</template>

<script>
  import loginUtil from "@/util/loginUtil";
  import ViewTable from "@/components/ViewTable";


  export default {
    name: "ToDoInvoiceList",
    components: {ViewTable},
    data() {
      return {
        limits: {
          addAuth: this.$auth(296),
          editAuth: this.$auth(703),
          delAuth: this.$auth(704),
          subAuth: this.$auth(8),
          creatDeliveryAuth: this.$auth(8),
          downLoadAuth: this.$auth(369),
          invoiceAuth: this.$auth(318),
        },
        authIndex: 369,
        importAuth: this.$auth(330),
        filter: {
          salesOrderNO: "",
          availableInvoice: "可开票",
          materialNo: "",
          specification: "",
          completeEndState: "",
          materialName: "",
          postingStatus: "",
          invoiceReceiveDesc: "",
          customerName: "",
          customerContractNo: "",
          employeeName: "",
          type: "",
          deliveryBeginDate: "",
          deliveryEndDate: "",
          postBeginDate: "",
          postEndDate: "",
          signEndDate: "",
          signBeginDate: "",
        },
        columnsProperty: [
          {
            key: "availableInvoice",
            width: 100,
            align: "center",
          },
          {
            key: "billNo",
            width: 100,
            ellipsis: true,
          },
          {
            key: "completeEndState",
            width: 100,
            align: "center",
          },
          {
            key: "deliveryCompletedTime",
            width: 160,
            align: "center",
          },
          {
            key: "postingStatus",
            width: 100,
            align: "center",
          },
          {
            key: "postingTime",
            width: 160,
          },
          {
            key: "invoiceReceiveDesc",
            width: 100,
            align: "center",
          },
          {
            key: "signedTime",
            align: "center",
            width: 160,
          },
          {
            key: "totalAmount",
            align: "center",
            width: 130,
          },
          {
            key: "customerName",
            align: "center",
            width: 200,
          },
          {
            key: "customerContractNo",
            align: "center",
            width: 160,
          },
          {
            key: "employeeName",
            align: "center",
            width: 100,
          },
          {
            key: "salesOrderNo",
            align: "center",
            width: 160,
          },
          {
            key: "materialNo",
            align: "center",
            width: 160,
          },
          {
            key: "materialName",
            align: "center",
            width: 160,
          },
          {
            key: "specification",
            align: "center",
            width: 160,
          },
          {
            key: "rowNum",
            align: "center",
            width: 80,
          },
          {
            key: "invoiceNum",
            align: "center",
            width: 80,
          },
          {
            key: "toDoNum",
            align: "center",
            width: 80,
          },
          {
            key: "unitToDoPrice",
            align: "center",
            width: 80,
          },
          {
            key: "totalToDoPrice",
            align: "center",
            width: 80,
          },
          // {
          //   key: "action",
          //   width: 250,
          //   slot: "action",
          //   fixed: "right",
          // },
        ],
        options: [],
        submitDateRange: [],
        createDateRange: [],
        deliveryDateRange: [],
        postDateRange: [],
        signDateRange: [],
        importCustomerId: "1963",
        YWTimportLoading: false,
        importLoading: false,
        importCustomerLoading: false,
        uploadUrl: window.config.basicServerUrl + "sd/so/importContractFile",
        uploadHeaders: {Authorization: loginUtil.getToken()},
        disabled: false,
        importPdfLoading: false,
        uploadLoading: false,
        selection: [],
        submitLoading: false,
      };
    },

    watch: {
      "filter.deliveryBeginDate": {
        handler(newVal) {
          if (newVal) {
            this.deliveryDateRange = [];
            this.deliveryDateRange.push(this.filter.deliveryBeginDate);
            this.deliveryDateRange.push(this.filter.deliveryEndDate);
          }
        },
      },
      "filter.signBeginDate": {
        handler(newVal) {
          if (newVal) {
            this.signDateRange = [];
            this.signDateRange.push(this.filter.signBeginDate);
            this.signDateRange.push(this.filter.signEndDate);
          }
        },
      },
      "filter.postBeginDate": {
        handler(newVal) {
          if (newVal) {
            this.postDateRange = [];
            this.postDateRange.push(this.filter.postBeginDate);
            this.postDateRange.push(this.filter.postEndDate);
          }
        },
      },
      "filter.orderBeginDate": {
        handler(newVal) {
          if (newVal) {
            this.createDateRange = [];
            this.createDateRange.push(this.filter.orderBeginDate);
            this.createDateRange.push(this.filter.orderEndDate);
          }
        },
      },
      "filter.submitBeginDate": {
        handler(newVal) {
          if (newVal) {
            this.submitDateRange = [];
            this.submitDateRange.push(this.filter.submitBeginDate);
            this.submitDateRange.push(this.filter.submitEndDate);
          }
        },
      },
    },

    // created() {
    //   this.getAreaOptions();
    // },

    methods: {
      loadData(pageNum) {
        this.$refs.viewTable.loadData(pageNum);
      },

      handle() {
        if (this.selection.length === 0) {
          this.$message.error("请先选择数据");
        } else if (this.selection.filter(item => item.availableInvoice !== "可开票").length) {
          this.$message.error("存在不可开票的明细!");
        } else {
          this.$router.push({
            path: "/InvoiceApplicationPreview",
            query: {
              billId: 0,
              $tabName: "开票申请",
              selection: this.selection,
            },
          });
        }
      },

      dateRangeChange(timeRange, timeStart, timeEnd) {
        if (this[timeRange]) {
          this.filter[timeStart] = this[timeRange][0];
          this.filter[timeEnd] = this[timeRange][1];
        } else {
          this.filter[timeStart] = "";
          this.filter[timeEnd] = "";
        }
      },

      // 上传文件
      uploadSuccess(fileList, row) {
        if (fileList.length) {
          this.uploadLoading = true;
          const params = {
            itemType: 10,
            fileName: fileList[0].name,
            filePath: fileList[0].key,
            itemID: row.salesOrderId,
          };
          this.$http.post("basic", "attachments", params)
            .then((res) => {
              if (res.success) {
                this.$message.success("上传成功");
              }
              this.uploadLoading = false;
            })
            .catch(() => {
              this.uploadLoading = false;
            });
        }
      },

      selectHandle(selection) {
        this.selection = selection;
      },

      resetHandle(filter) {
        this.filter = Object.assign(this.filter, filter);
      },

      addEditHandle() {
        this.$router.push({
          path: "/InvoiceApplicationPreview",
          query: {
            billId: 0,
            $tabName: "开票申请",
            selection: [],
          },
        });
      },

      // 获取所属区域列表
      getAreaOptions() {
        this.$http.get("basic", "districts/selectAllDistrict").then((res) => {
          if (res.success) {
            this.options = res.data;
          }
        });
      },

      // 删除
      deleteHandle(row) {
        this.$http.delete("basic", "sapSalesOrders", row.pkId).then((resp) => {
          if (resp.success) {
            this.loadData();
            this.$message.success("删除成功");
          }
        });
      },

      // 提交
      submitHandle(row) {
        let ids = [row.pkId];
        this.$confirm("确定提交吗?", "提示", {type: "warning"}).then(() => {
          this.$http.post("basic", `sapSalesOrders/submitBatch/${ids}`).then((resp) => {
            if (resp.success) {
              this.$message.success("提交成功");
              this.loadData();
            }
          });
        });
      },

      // 复制(只能复制状态为通过的数据)
      copyHandle(row) {
        this.$refs.salesOrderEdit.open(row, 1);
      },

      // 未提交、退单可以编辑删除
      otherAuth(row) {
        if (row.status === 10 || row.status === 12) {
          return false;
        } else {
          return true;
        }
      },

      beforeAvatarUpload(file) {
        let fileName = file.name;
        let pos = fileName.lastIndexOf(".");
        let lastName = fileName.substring(pos, fileName.length);
        if (lastName.toLowerCase() !== ".xlsx" && lastName.toLowerCase() !== ".xls") {
          this.$message.error("请上传.xlsx或.xls文件类型");
        }
      },

      onExceed() {
        this.$message.error("一次只能导入一张表，请刷新后再导入");
      },
      handleSuccess(data) {
        if (data.success) {
          this.importLoading = false;
          this.disabled = false;
          this.$message.success("成功导入新的数据");
          this.loadData(1);
        } else {
          this.importLoading = false;
          this.disabled = false;
          this.$message.error(data.message);
        }
      },
      onProgress() {
        this.importLoading = true;
        this.disabled = true;
      },
      handlerError(err) {
        this.importLoading = false;
        this.disabled = false;
        err = JSON.parse(err.message);
        alert("导入失败\n" + err.message);
      },
    },
  };
</script>
